import { useState } from "react";
import { api } from "../api";
import { useT } from "../i18n";
import { useApi } from "../ui";

/** Ask AI (docs/37 S9): the copilot's station persona; with a quote, it drafts the client's proposal text. */
export function AskDrawer({ initial, quoteId: q0, onClose }: { initial?: string | undefined; quoteId?: string | undefined; onClose: () => void }) {
  const t = useT();
  const [text, setText] = useState(initial ?? "");
  const [quoteId, setQuoteId] = useState(q0 ?? "");
  const [conv, setConv] = useState<string>();
  const [log, setLog] = useState<{ who: "me" | "ai"; text: string; safe?: boolean }[]>([]);
  const [busy, setBusy] = useState(false);
  const quotes = useApi<{ quotes: { id: string; title: string; reference: string; client?: { name: string } }[] }>("/quotes");
  const send = async () => {
    if (!text.trim()) return;
    const asked = text;
    setLog((l) => [...l, { who: "me", text: asked }]); setText(""); setBusy(true);
    try {
      const r = await api<{ conversationId: string; text: string; clientSafe: boolean; error?: string }>("/ask", { body: { text: asked, ...(quoteId ? { quoteId } : {}), ...(conv ? { conversationId: conv } : {}) } });
      setConv(r.conversationId);
      setLog((l) => [...l, { who: "ai", text: r.text || r.error || "…", safe: r.clientSafe }]);
    } catch (e) { setLog((l) => [...l, { who: "ai", text: (e as Error).message }]); } finally { setBusy(false); }
  };
  return (
    <div className="pd-ov" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <aside className="pd" role="dialog" aria-modal="true" aria-label={t("ask.title")}>
        <button type="button" className="pd-x" aria-label={t("common.close")} onClick={onClose}>×</button>
        <div className="pd-body">
          <span className="eyebrow">Station AI</span><h3>{t("ask.title")}</h3>
          <label className="f" style={{ margin: ".8rem 0" }}>{t("ask.quote")}<select value={quoteId} onChange={(e) => setQuoteId(e.target.value)}><option value="">—</option>{quotes.data?.quotes.map((q) => <option key={q.id} value={q.id}>{q.reference} · {q.title}{q.client ? ` · ${q.client.name}` : ""}</option>)}</select></label>
          <div data-testid="ask-log">{log.map((m, i) => <div key={i} className="card" style={{ padding: ".8rem", background: m.who === "me" ? "var(--side)" : "var(--surface)" }}><p style={{ whiteSpace: "pre-wrap" }}>{m.text}</p>{m.who === "ai" && m.safe !== undefined ? <small className="muted" data-testid="ask-safe">{m.safe ? t("ask.safe") : t("ask.unsafe")}</small> : null}</div>)}{busy ? <p className="muted">…</p> : null}</div>
          <form className="mform" onSubmit={(e) => { e.preventDefault(); void send(); }}><textarea rows={3} value={text} placeholder={t("ask.placeholder")} onChange={(e) => setText(e.target.value)} /><div className="q-actions"><button className="btn ink" type="submit" disabled={busy}>{t("inbox.send")}</button></div></form>
        </div>
      </aside>
    </div>
  );
}
